import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css',
})
export class MainComponent {
  user: any;
  nombres: string = '';
  apellidos: string = '';
  idRol: number | null = null;
  options: Array<any> = [];
  allOptions = [
    {
      name: 'Documentos',
      icon: 'fas fa-file-alt',
      route: '/documentos',
      roles: [1, 2],
    },
    {
      name: 'Instituciones',
      icon: 'fas fa-school',
      route: '/instituciones',
      roles: [1],
    },
    {
      name: 'Especialistas',
      icon: 'fas fa-user-tie',
      route: '/especialistas-documentacion',
      roles: [1],
    },
    {
      name: 'Evaluaciones',
      icon: 'fas fa-list-alt',
      route: '/evaluaciones',
      roles: [1, 3],
    },
    {
      name: 'Evaluaciones',
      icon: 'fas fa-clipboard-check',
      route: '/evaluaciones-estudiante',
      roles: [4],
    },
    {
      name: 'Estudiantes',
      icon: 'fas fa-user-graduate',
      route: '/estudiantes',
      roles: [1],
    },
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        this.user = JSON.parse(storedUser);
        this.idRol = this.user?.id_rol ?? null; // Obtiene el idRol del usuario si está disponible
        this.nombres = this.user?.nombres ?? '';
        this.apellidos = this.user?.apellidos ?? '';
        this.filterOptions(); // Filtra las opciones según el rol
      } else {
        // console.log('No hay usuario en localStorage, redirigiendo al login...');
        this.router.navigate(['/login']);
      }
    } else {
      // console.log('localStorage no está disponible en este entorno');
    }
  }

  filterOptions(): void {
    if (this.idRol !== null) {
      this.options = this.allOptions.filter((option) =>
        option.roles.includes(this.idRol!)
      );
    } else {
      this.options = []; // Si no hay idRol, no muestra opciones
    }
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  logout(): void {
    // Elimina el usuario del localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('evaluacionEnProgreso');
    localStorage.removeItem('user');
    // Redirige al usuario a la página de inicio (home)
    this.router.navigate(['/home']);
  }
  getNameRol() {
    switch (this.idRol) {
      case 1:
        return 'Administrador';
      case 2:
        return 'Especialista en Documentacion';
      case 3:
        return 'Especialista en Evaluaciones';
      case 4:
        return 'Estudiante';
      case 5:
        return 'Institución Educativa';
      default:
        return 'Desconocido';
    }
  }
}
